var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilestoneExtraLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 48",
    width: 90,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "milestone-line-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #707070 } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: none;stroke: #dc7236 } \n\t\t.s3 { fill: #dc7236 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    className: "s0",
    d: "m0 24h384"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m192 48c-13.3 0-24-10.7-24-24 0-13.3 10.7-24 24-24 13.3 0 24 10.7 24 24 0 13.3-10.7 24-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m192 47.5c-13 0-23.5-10.5-23.5-23.5 0-13 10.5-23.5 23.5-23.5 13 0 23.5 10.5 23.5 23.5 0 13-10.5 23.5-23.5 23.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_23-2",
    className: "s3",
    d: "m192 40c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16 8.8 0 16 7.2 16 16 0 8.8-7.2 16-16 16z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneExtraLine);
export default __webpack_public_path__ + "static/media/milestone-extra-line.9d12b1fef787c1643cbb745e001b2aae.svg";
export { ForwardRef as ReactComponent };